module.exports = __webpack_public_path__ + "static/media/duanwuBg3.f97ac66c.png";